import { ButtonGroupHorizontalScroll } from './horizontal-scroll';
import { ButtonGroupNoWrap } from './no-wrap';
import { ButtonGroupWrap } from './wrap';

export const ButtonGroup = {
  HorizontalScroll: ButtonGroupHorizontalScroll,
  NoWrap: ButtonGroupNoWrap,
  Wrap: ButtonGroupWrap
};
